import { render, staticRenderFns } from "./UserReservationsList.vue?vue&type=template&id=069a82d2&"
import script from "./UserReservationsList.vue?vue&type=script&lang=js&"
export * from "./UserReservationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports